import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import ReactCountryFlag from 'react-country-flag';

import logo from '../../relaystream-logo.png';
import './Header.css';
import { translate } from 'react-i18next';

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeLanguage: ''
    };
  }

  componentDidMount() {
    const activeLanguage = "Portuguese";
    
    const allLanguages = [
      {langName: 'Portuguese', countryCode: 'BR'}
    ];


    allLanguages.forEach(language => {
      if(language.langName == activeLanguage) {
        this.setState({activeLanguage: language.countryCode});
      }
    });
    
  }

  render() {

    const currentLocationPath = this.props.location.pathname;
    const { matchPaths, t, i18n } = this.props;

    const changeLanguage = (lng) => {
      localStorage.setItem('locale', lng);
    }

    return (
      <div className="container-fluid Header">
        <div className="container">

          <nav className="navbar navbar-expand-lg navbar-light">
            {/* relayStream Logo */}
            <Link to="/" className="navbar-brand">
              <img className="relayStreamLogo" src={logo} alt="relay stream logo" />
            </Link>

            {/* Button to toggle navbar with language dropdown and signup/login button */}
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>

            {/* collapsible navbar with laguage change dropdown and signup/login button */}
            <div className="collapse navbar-collapse" id="navbarSupportedContent">


              <ul className="navbar-nav ml-auto align-iitems-center">


                {/* Dropdown to change language */}
                <li className="nav-item dropdown mr-4">
                  <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a className="dropdown-item mr-3" onClick={() => this.setState({ activeLanguage: 'BR' }, changeLanguage('Portuguese'))}>
                      <ReactCountryFlag code="BR" svg />
                      <span className="ml-2 vertical-align-middle"> Portuguese </span>
                    </a>
                  </div>
                </li>

                {/* Codes to switch between login and signup buttons based on current url */}

                {/* login butoon vissible only on homepage, signup page, password reset request page, password reset page */}
                {(currentLocationPath !== '/login' && (currentLocationPath === '/' || matchPaths)) ? <li className="nav-item">
                  <Link to="/login" className="nav-link">
                    <button className="mx-auto btn btn-sm btn-outline-secondary btn-nav-login">{t('LOG_IN')}</button>
                  </Link>
                </li> : null}

                {/* signup button visible only on login */}
                {currentLocationPath === '/login' ? <li className="nav-item">
                  <Link to="/signup" className="nav-link">
                    <button className="mx-auto btn btn-sm btn-outline-secondary btn-nav-login">{t('SIGN_UP')}</button>
                  </Link>
                </li> : null} 

              </ul>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

export default withRouter(translate('translations')(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js